import { lazy } from 'react';

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const CardholderAccountEditViewChunk = lazy(() =>
  import('../feature-sets/CardholderAccountEditView').then(
    ({ CardholderAccountEditView }) => ({
      default: CardholderAccountEditView,
    })
  )
)

export const CardholderAccountEditPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.cardholderAccountEditPageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.cardholderAccountPageTitle),
          link: url('CardholderAccountPage'),
        },
        {
          name: intl.formatMessage(messages.cardholderAccountEditPageTitle),
        },
      ]}
    >
      <CardholderAccountEditViewChunk />
    </Page>
  )
}
